<template>
  <v-container fluid class="purchaseorder-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-purchaseorder`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Order
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-details`">
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab v-if="isTrade" :href="`#tab-trade`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-check-outline</v-icon>
            Terms
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-purchaseorder'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Purchase Order</p>
                      <v-select
                        class="mb-4"
                        :items="purchaseordertype"
                        v-model="initial_value.purchaseordertype"
                        v-on:change="
                          updateChangedValue($event, 'purchaseordertype')
                        "
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the sales order type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_purchaseorderdate"
                        v-model="menu_purchaseorderdate"
                        :close-on-content-click="false"
                        :return-value.sync="purchaseorderdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="purchaseorderdate"
                            label="Purchase Order Date"
                            v-bind="attrs"
                            v-bind:value="purchaseorderdate"
                            v-on:change="
                              updateChangedValue($event, 'purchaseorderdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the sales order type"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="purchaseorderdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_purchaseorderdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              updateChangedValue(
                                purchaseorderdate,
                                'purchaseorderdate'
                              );
                              $refs.menu_purchaseorderdate.save(purchaseorderdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-switch
                        v-model="initial_value.purchaseorderstatus"
                        v-on:change="
                          updateChangedValue($event, 'purchaseorderstatus')
                        "
                        color="primary"
                        v-bind:label="initial_value.purchaseorderstatus"
                        value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="
                          vendors.filter(vendor=>vendor.vendortype=='Supplier').map((x) => {
                            return { text: x.vendorname, value: x._id };
                          })
                        "
                        v-model="initial_value.vendorid"
                        v-bind:error="errorindex == 2"
                        v-on:change="
                          populateVendorFields;
                          updateChangedValue($event, 'vendorid');
                        "
                        outlined
                        dense
                        placeholder="Vendor"
                        persistent-hint
                        single-line
                        hint="Please choose the vendor"
                      >
                      </v-select>
                      <v-text-field
                        outlined
                        dense
                        class="mb-4"
                        v-model="initial_value.purchaseordername"
                        v-on:change="
                          updateChangedValue($event, 'purchaseordername')
                        "
                        v-bind:error="errorindex == 10"
                        placeholder="Vendor Name"
                        persistent-hint
                        single-line
                        hint="Enter the Vendor Name"
                      >
                      </v-text-field>
                      <v-textarea
                        outlined
                        v-model="initial_value.purchaseorderaddress"
                        v-on:change="
                          updateChangedValue($event, 'purchaseorderaddress')
                        "
                        rows="2"
                        label="Address"
                        hint="please enter the vendor address"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="
                          regions.map((x) => {
                            return { text: x.regionname, value: x._id };
                          })
                        "
                        v-model="initial_value.regionid"
                        v-on:change="updateChangedValue($event, 'regionid')"
                        v-bind:error="errorindex == 3"
                        outlined
                        dense
                        placeholder="Region"
                        persistent-hint
                        single-line
                        hint="Please choose the region"
                      >
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        v-model="initial_value.purchaseorderphone"
                        v-on:change="
                          updateChangedValue($event, 'purchaseorderphone')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Phone"
                        persistent-hint
                        single-line
                        hint="Enter the phone"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        v-model="initial_value.purchaseordermobile"
                        v-on:change="
                          updateChangedValue($event, 'purchaseordermobile')
                        "
                        v-bind:error="errorindex == 12"
                        outlined
                        dense
                        placeholder="Mobile"
                        persistent-hint
                        single-line
                        hint="Enter the mobile phone"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="
                          pricelists.map((x) => {
                            return { text: x.pricelistname, value: x._id };
                          })
                        "
                        v-model="initial_value.pricelistid"
                        v-on:change="updateChangedValue($event, 'pricelistid')"
                        v-bind:error="errorindex == 4"
                        outlined
                        dense
                        placeholder="Price List"
                        persistent-hint
                        single-line
                        hint="Please choose the pricelist"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="purchaseorderpayterms"
                        v-model="initial_value.purchaseorderpayterms"
                        v-on:change="
                          updateChangedValue($event, 'purchaseorderpayterms')
                        "
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Pay Terms"
                        persistent-hint
                        single-line
                        hint="Please choose the pay terms"
                      >
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        v-model="initial_value.purchaseordernote"
                        v-on:change="
                          updateChangedValue($event, 'purchaseordernote')
                        "
                        v-bind:error="errorindex == 10"
                        outlined
                        dense
                        placeholder="Note"
                        persistent-hint
                        single-line
                        hint="Enter the note"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchaseorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="editItem()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <p class="text-h5">Items</p>
                    <v-form>
                      <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="
                              brands.map((x) => {
                                return { text: x.brandname, value: x._id };
                              })
                            "
                            v-model="brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line
                            hint="Brand"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="4">
                          <v-select
                            class="mb-4"
                            :items="branditems"
                            v-model="itemid"
                            v-bind:error="errorindex == 0"
                            v-on:change="populatePriceField"
                            outlined
                            dense
                            placeholder="Item"
                            persistent-hint
                            single-line
                            hint="Item"
                          >
                          </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 1) this.value = 1;"
                            single-line
                            hint="Quantity"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="itemprice"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line
                            hint="Price"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            readonly
                            v-model="itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line
                            hint="Amount"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addTransaction()"
                          >
                            Add
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="headers"
                        :items="transactions"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="dialog" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ deletetransaction.itemname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="dialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteItem(deletetransaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="loadTransaction(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <template slot="body.append">
                          <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Subtotal</th>
                            <th>{{ purchaseorder.purchaseordersubtotal }}</th>
                            <th></th>
                          </tr>
                          <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>Total</th>
                            <th>{{ purchaseorder.purchaseordersubtotal }}</th>
                            <th></th>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchaseorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="isTrade" :value="'tab-trade'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Trade Terms</p>
                      <v-text-field
                        class="mb-4"
                        v-model="initial_value.trade.refnum"
                        v-on:change="updateTradeValue($event, 'refnum')"
                        outlined
                        dense
                        placeholder="Reference Number"
                        persistent-hint
                        single-line
                        hint="Enter reference number"
                      >
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="incoterms"
                        v-model="initial_value.trade.incoterms"
                        v-on:change="updateTradeValue($event, 'incoterms')"
                        outlined
                        dense
                        placeholder="Incoterms"
                        persistent-hint
                        single-line
                        hint="Please enter incoterms"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-menu
                        ref="menu_etddate"
                        v-model="menu_etddate"
                        :close-on-content-click="false"
                        :return-value.sync="etddate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="etddate"
                            label="ETD Date"
                            v-bind="attrs"
                            v-bind:value="etddate"
                            v-on:change="updateTradeValue($event, 'etddate')"
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            persistent-hint
                            hint="Enter ETD date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker v-model="etddate" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_etddate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              updateTradeValue(etddate, 'etddate');
                              $refs.menu_etddate.save(etddate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_etadate"
                        v-model="menu_etadate"
                        :close-on-content-click="false"
                        :return-value.sync="etadate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            outlined
                            dense
                            v-model="etadate"
                            label="ETA Date"
                            v-bind="attrs"
                            v-bind:value="etadate"
                            v-on:change="updateTradeValue($event, 'etadate')"
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            persistent-hint
                            hint="Enter ETA date"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker v-model="etadate" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_etadate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              updateTradeValue(etadate, 'etadate');
                              $refs.menu_etadate.save(etadate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        v-model="initial_value.trade.portloading"
                        v-on:change="updateTradeValue($event, 'portloading')"
                        outlined
                        dense
                        placeholder="Port of Loading"
                        persistent-hint
                        single-line
                        hint="Enter the loading port"
                      >
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        v-model="initial_value.trade.portdischarge"
                        v-on:change="updateTradeValue($event, 'portdischarge')"
                        outlined
                        dense
                        placeholder="Port of Discharge"
                        persistent-hint
                        single-line
                        hint="Enter the discharge port"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchaseorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="editTradeItem()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="filedialog = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="fileHeaders"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="deletefiledialog" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ deletefile.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="deletefiledialog = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(deletefile)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchaseorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
      <v-row justify="center">
    <v-dialog
      v-model="filedialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload File</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
              <v-file-input label="File input" v-on:change="onFileChange" accept=".pdf" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="upload.filename"
                  label="File Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="filedialog = false; upload.file=null; upload.filename=''"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="upload.file == null || upload.filename.length<2"
            color="blue darken-1"
            text
            @click="uploadFile"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
      <v-bottom-sheet v-model="sheet" inset>
        <v-sheet class="text-center" height="220px">
          <v-btn class="mt-6" text color="error" @click="sheet = !sheet">
            close
          </v-btn>
          <v-row justify="center">
            <v-col cols="12" md="2">
              <v-select
                class="mb-4"
                :items="
                  brands.map((x) => {
                    return { text: x.brandname, value: x._id };
                  })
                "
                v-model="brandid"
                v-bind:error="errorindex == 2"
                v-on:change="populateItems"
                outlined
                dense
                placeholder="Brand"
                persistent-hint
                single-line
                hint="Brand"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                class="mb-4"
                :items="branditems"
                v-model="itemid"
                v-bind:error="errorindex == 0"
                v-on:change="populatePriceField"
                outlined
                dense
                placeholder="Item"
                persistent-hint
                single-line
                hint="Item"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="itemquantity"
                class="mb-4"
                outlined
                dense
                placeholder="Qty"
                persistent-hint
                type="number"
                v-on:input="calculateAmount"
                oninput="if(this.value < 1) this.value = 1;"
                single-line
                hint="Qty"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                readonly
                v-model="itemprice"
                class="mb-4"
                outlined
                dense
                placeholder="Prc"
                persistent-hint
                single-line
                hint="Price"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                readonly
                v-model="itemamount"
                class="mb-4"
                outlined
                dense
                placeholder="Amt"
                persistent-hint
                single-line
                hint="Amount"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-btn
            class="button-shadow"
            color="warning"
            @click="editTransaction()"
          >
            Edit
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/Routes";
import axios from "axios";

export default {
  data() {
    return {
      headers: [
        { text: "Image", value: "itemimage" },
        { text: "Name", value: "itemname" },
        { text: "Foc", value: "itemfoc" },
        { text: "Qty", value: "itemquantity" },
        { text: "Prc", value: "itemprice" },
        { text: "Amount", value: "itemamount" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      access: [],
      accessname: undefined,
      accesspath: undefined,
      accessenabled: undefined,
      detail: {},
      deletetransaction: {},
      deletefile: {},
      trade: {},
      files: [],
      editedIndex: -1,
      editedItem: {
        _id: undefined,
        accessname: undefined,
        accesspath: undefined,
        accessenabled: undefined,
      },
      purchaseorder: {},
      sheet: false,
      filedialog: false,
      brandid: undefined,
      price: undefined,
      cid: undefined,
      itemimage: undefined,
      itemid: undefined,
      itemname: undefined,
      itemquantity: 1,
      itemfoc: undefined,
      itemprice: undefined,
      itemamount: undefined,
      itemcategoryid: undefined,
      itemsubcategoryid: undefined,
      branditems: [],
      menu_purchaseorderdate: false,
      menu_etddate: false,
      menu_etadate: false,
      purchaseorderdate: null,
      etddate: null,
      etadate: null,
      employeestartdate: null,
      purchaseordertype: ["Purchase Order", "Cash Order", "Pre Order"],
      purchaseorderpayterms: ["Cash", "Credit 15 Days", "Credit 30 Days"],
      incoterms: ["FOB", "CIF", "Ex-works"],
      transactions: [],
      date2: null,
      menu1: false,
      menu2: false,
      dialog: false,
      deletefiledialog: false,
      isTrade: false,
      editdialog: false,
      pin: {
        error: false,
        error2: false,
      },
      initial_value: {},
      imageurl: undefined,
      upload: {
        filename: null,
        file: null,
      },
      error: ["Access Name is required", "Access path is required"],
      errorindex: undefined,
    };
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Vendor", ["getVendorsRequest"]),
    ...mapActions("File", ["insertPurchaseOrderFile", "deleteFileRequest", "getPurchaseOrderFiles"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions("PurchaseOrder", ["updatePurchaseOrderRequest","updatePurchaseOrderTrade",]),
    ...mapActions("Region", ["getRegionsRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    populateVendorFields(vendorid) {
      var vendor = this.vendors.find(
        (vendor) => vendor._id == vendorid
      );
      this.purchaseorder.purchaseordername = vendor.vendorname;
      this.purchaseorder.purchaseorderaddress = vendor.vendoraddress;
      this.purchaseorder.purchaseorderphone = vendor.vendorphone;
      this.purchaseorder.purchaseordermobile = vendor.vendormobile;
      this.purchaseorder.regionid = vendor.regionid;
      this.purchaseorder.pricelistid = vendor.pricelistid;
    },
    populateItems(brandid) {
      let items = this.items.filter((item) => item.brandid == brandid);
      this.branditems = items.map((x) => {
        return { text: x.itemname, value: x._id };
      });
    },
    populatePriceField(itemid) {
      let price = this.prices.find(
        (price) =>
          price.itemid == itemid &&
          price.pricelistid == this.initial_value.pricelistid
      );
      let item = this.items.find((item) => item._id == itemid);
      this.price = price;
      this.itemprice = price.listprice;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
      this.calculateAmount();
    },
    calculateAmount() {
      this.itemamount = this.itemquantity * this.itemprice;
    },
    calculateTotal() {
      this.purchaseorder.purchaseordersubtotal = this.transactions.reduce(
        (a, b) => a + (b["itemamount"] || 0),
        0
      );
      this.purchaseorder.purchaseordertotal = this.purchaseorder.purchaseordersubtotal;
    },
    clearTransaction() {
      this.cid = undefined;
      this.itemid = undefined;
      this.itemimage = undefined;
      this.itemname = undefined;
      this.itemquantity = 1;
      this.itemprice = undefined;
      this.itemamount = undefined;
      this.itemcategoryid = undefined;
      this.itemsubcategoryid = undefined;
    },
    loadTransaction(item) {
      this.cid = item._id;
      this.sheet = !this.sheet;
      this.brandid = this.items.find((x) => x._id == item.itemid)["brandid"];
      this.populateItems(this.brandid);
      this.itemid = item.itemid;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemquantity = item.itemquantity;
      if (this.itemfoc == "foc") {
        this.itemprice = 0;
      } else {
        this.itemprice = item.itemprice;
      }

      this.itemamount = item.itemamount;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
    },
    async editItem() {
      this.purchaseorder._id = this.initial_value._id;
      await this.updatePurchaseOrderRequest(this.purchaseorder);
      router.push("/purchaseorder/list");
    },
    async editTradeItem() {
      this.trade._id = this.initial_value._id;
      await this.updatePurchaseOrderTrade(this.trade);
      router.push("/purchaseorder/list");
    },
    addTransaction() {
      if (this.itemprice == null || this.itemamount == null) {
        return;
      }
      let data = {
        regionid: this.initial_value.regionid,
        vendorid: this.initial_value.vendorid,
        brandid: this.brandid,
        itemid: this.itemid,
        itemimage: this.itemimage,
        itemname: this.itemname,
        itemquantity: this.itemquantity,
        itemfoc: "",
        itemprice: this.itemprice,
        itemamount: this.itemamount,
        itemcategoryid: this.itemcategoryid,
        itemsubcategoryid: this.itemsubcategoryid,
      };

      let token = localStorage.getItem("token");
      let url =
        "https://api.accountxc.com:3100/add/purchaseorder/transaction/" +
        this.initvalue._id;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };

      axios({ method: "post", url: url, headers: headers, data: data }).then(
        (response) => {
          this.transactions.push(response.data);
          this.calculateTotal();
          this.clearTransaction();
        }
      );
    },
    async uploadFile(){
      this.upload.purchaseorderid = this.initvalue._id;
      this.filedialog = false;
      let file = await this.insertPurchaseOrderFile(this.upload);
      this.files.push(file);
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletetransaction = {
        _id: item._id,
        itemname: item.itemname,
        itemquantity: item.itemquantity,
      };
    },
    deleteFileDialog(item) {
      this.deletefiledialog = true;
      this.deletefile = {
        _id: item._id,
        filename: item.filename,
      };
    },
    deleteTransaction(payload) {
      let token = localStorage.getItem("token");
      let url =
        "https://api.accountxc.com:3100/delete/purchaseorder/transaction/" +
        payload._id;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };

      axios({ method: "delete", url: url, headers: headers }).then(
        (response) => {
          let index = this.transactions.findIndex(
            (trans) => trans._id == response.data._id
          );
          this.transactions.splice(index, 1);
        }
      );
    },
    async deleteFile(payload) {
      this.deletefiledialog = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    onFileChange(file) {
      if (!file) {
        this.upload.file = null;
        return;
      }
      this.upload.file = file;
    },
    editTransaction() {
      if (this.itemprice == null || this.itemamount == null) {
        return;
      }
      let data = {
        cid: this.cid,
        regionid: this.initial_value.regionid,
        vendorid: this.initial_value.vendorid,
        brandid: this.brandid,
        itemid: this.itemid,
        itemimage: this.itemimage,
        itemname: this.itemname,
        itemquantity: this.itemquantity,
        itemfoc: this.itemfoc,
        itemprice: this.itemprice,
        itemamount: this.itemamount,
        itemcategoryid: this.itemcategoryid,
        itemsubcategoryid: this.itemsubcategoryid,
      };
      let token = localStorage.getItem("token");
      let url =
        "https://api.accountxc.com:3100/update/purchaseorder/transaction/" + data.cid;
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      };

      axios({ method: "put", url: url, headers: headers, data: data }).then(
        (response) => {
          let index = this.transactions.findIndex(
            (trans) => trans._id == response.data._id
          );
          this.transactions.splice(index, 1, response.data);
          this.sheet = !this.sheet;
          this.calculateTotal();
          this.clearTransaction();
        }
      );
    },
    updateChangedValue(value, field) {
      this.purchaseorder[field] = value;
    },
    updateTradeValue(value, field) {
      this.trade[field] = value;
    },
    deleteItem(item) {
      this.deleteTransaction({ _id: item._id });
      this.dialog = false;
    },
    deleteItemDialog(item) {
      this.dialog = true;
      this.deletetransactionaccess = {
        _id: item._id,
        accessname: item.accessname,
      };
    },
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Vendor", ["vendors"]),
    ...mapState("Item", ["items"]),
    ...mapState("Price", ["prices"]),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState("Region", ["regions"]),
    ...mapState("PurchaseOrder", ["isReceiving"]),
  },
  async created() {
    this.initvalue = this.$route.params;
    this.initial_value = this.initvalue;
    if (!this.initial_value._id) this.$router.push({ name: "PurchaseOrderList" });
    if (this.brands.length == 0) {
      this.getBrandsRequest();
    }
    if (this.vendors.length == 0) {
      this.getVendorsRequest();
    }
    if (this.items.length == 0) {
      this.getItemsRequest();
    }
    if (this.prices.length == 0) {
      this.getPricesRequest();
    }
    if (this.pricelists.length == 0) {
      this.getPriceListsRequest();
    }
    if (this.regions.length == 0) {
      this.getRegionsRequest();
    }
    if (this.regions.length == 0) {
      this.getRegionsRequest();
    }
    this.files = await this.getPurchaseOrderFiles(this.initvalue._id);
    if (this.initial_value.purchaseorderdate !== null) {
      let date = new Date(this.initial_value.purchaseorderdate);
      let month =
        date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      this.purchaseorderdate =
        date.getFullYear() + "-" + month + "-" + date.getDate();
    }
    if (this.initial_value.trade.etddate !== null) {
      let date = new Date(this.initial_value.trade.etddate);
      let month =
        date.getMonth() < 9 ? "0" + (date.getMonth() + 1).toString(): (date.getMonth() + 1).toString();
      this.etddate = date.getFullYear() + "-" + month + "-" + date.getDate();
    }
    if (this.initial_value.trade.etadate !== null) {
      let date = new Date(this.initial_value.trade.etadate);
      let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
      this.etadate = date.getFullYear() + "-" + month + "-" + date.getDate();
    }
    this.transactions = this.initial_value.transaction;
    this.calculateTotal();
    var companyid = localStorage.getItem("companyid");
    if (companyid == "60a8acb67418a3429476cd42") {
      this.isTrade = true;
      this.purchaseorderpayterms = ["100% TT", "Credit 15 Days", "Credit 30 Days"];
    }
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
